<template>
    <div>
        <div class="white-box md:mb-5">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isGettingData>0" />
                <div v-else>
                    <h4 class="text-error mb-2.5 font-normal">
                        {{ '您目前的繳費方式為' + payText }}
                    </h4>

                    <!-- <div class="border-t border-gray-100 text-base mb-7 py-4 md:py-5"> -->
                    <div class="border-t border-gray-100 text-base mb-7 pt-4 pb-2 md:py-5 text-gray-900">
                        <transition
                            name="opacity"
                            mode="out-in"
                        >
                            <div
                                v-if="!content.length"
                                class="overflow-hidden"
                            >
                                <SkeletonTerm
                                    v-for="n in 2"
                                    :key="n"
                                />
                            </div>
                            <div
                                v-else
                                class="terms"
                                v-html="content"
                            />
                        </transition>
                    </div>
                    <!-- </div> -->
                </div>
            </transition>
        </div>
        <Bottombar>
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    :disabled="isGettingData>0"
                    @click="saveAndgoNext"
                />
            </template>
        </Bottombar>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { getAgreeTermsD1, postAgreeD1, getInfoD1, submitD1 } from '@/apis/D1';
import { useStore } from 'vuex';
import Loading from '@/components/Loading.vue';
import Skeletons from '@/components/skeletons/Skeletons.vue';
import Bottombar from '@/components/layout/Bottombar.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import SkeletonTerm from '@/components/skeletons/SkeletonTerm.vue';

export default {
    components: {
        Bottombar,
        Loading,
        ButtonNextService,
        Skeletons,
        SkeletonTerm,
    },
    setup() {
        const route = useRoute();
        const { code } = route.meta;
        const store = useStore();
        const isLoading = ref(false);
        const isGettingData = ref(0);
        const payText = ref('');
        const isApply = ref('N');
        const isSubmitOk = ref(false);
        const content = ref('');

        const getData = async () => {
            isGettingData.value = 2;
            /** 取得條款內容 */
            await getAgreeTermsD1().then((res) => {
                content.value = res.data.agreeTerms.content;
            }).finally(() => {
                isGettingData.value -= 1;
            });
            await getInfoD1().then((res) => {
                payText.value = res.data.payKind;
            }).finally(() => {
                isGettingData.value -= 1;
            });
        };

        getData();

        const saveAndgoNext = () => {
            isLoading.value = true;
            isApply.value = 'Y';
            postAgreeD1().then(() => {
                const returnData = {
                    // isApply: isApply.value === 'Y',
                };
                submitD1(returnData).then(() => {
                    isSubmitOk.value = true;
                    const value = {
                        storeIsApply: isApply.value,
                    };
                    store.dispatch('services/setChangeItemsResult', { code, value });
                }).finally(() => {
                    isLoading.value = false;
                });
            }).catch(() => {
                isLoading.value = false;
            });
        };
        return {
            isGettingData,
            isLoading,
            isSubmitOk,
            payText,
            content,
            isApply,
            saveAndgoNext,
        };
    },
};
</script>

<style lang="scss" scoped>
:deep(.terms) {
    ul {
        @apply ml-6;
        li {
            margin-bottom: 0.3rem;
        }
    }
}
</style>
